// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { MonolithImageSizeFragmentDoc } from '../../../components/useImageProps.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { MoneyFragmentDoc } from '../fragments/money.fragment.generated';
import { AffirmFinanceOptionsFragmentDoc } from '../checkout/payment/affirmFinanceOptions.fragment.generated';
import { KlarnaFinanceOptionsFragmentDoc } from '../checkout/payment/klarnaFinanceOptions.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { ProductPageMetaFragmentDoc } from '../../../views/product/composables/useProductPageMeta.generated';
import { CatalogueEngagementRingInputFragmentDoc } from './catalogueEngagementRingInput.fragment.generated';
import { SignatureStoneInputFragmentDoc } from '../product/rings/engagement/ring/fragments/signatureStoneInput.fragment.generated';
import { StoneFragmentDoc } from '../stone/gems/fragments/stone.fragment.generated';
import { GemsApiCertificateFragmentDoc } from '../../../domain/stone/certificate.generated';
import { GemsApiStoneAnalyticsFragmentDoc, NonSkuGemstoneAnalyticsFragmentDoc, NonSkuLabGrownAnalyticsFragmentDoc } from '../../../views/product/composables/analytics/useProductAnalytics.generated';
import { NonSkuGemstoneFragmentDoc } from '../stone/nonsku/fragments/nonSkuGemstone.fragment.generated';
import { NonSkuLabGrownFragmentDoc } from '../stone/nonsku/fragments/nonSkuLabGrown.fragment.generated';
import { RecommendedRingSizeFragmentDoc } from '../product/rings/fragments/recommendedRingSize.fragment.generated';
import { RingSizeFragmentDoc } from '../product/rings/fragments/ringSize.fragment.generated';
export const RingBuilderMountEngagementRingFragmentDoc = gql`
    fragment ringBuilderMountEngagementRing on CatalogueEngagementRing {
  __typename
  ...engagementRingLink
  ...catalogueEngagementRingInput
  productName
  catalogueCode
  images {
    small_x2: size(name: SMALL_X2) {
      ...monolithImageSize
    }
    large_x2: size(name: LARGE_X2) {
      ...monolithImageSize
    }
  }
  primaryMetal {
    translation(locale: $locale) {
      name
    }
    systemCode
  }
  suffix
  centreStoneConstraints {
    shape {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    weight {
      max
      min
    }
  }
  sizes(region: $region) {
    __typename
    ...recommendedRingSize
    ...ringSize
  }
}
    ${EngagementRingLinkFragmentDoc}
${CatalogueEngagementRingInputFragmentDoc}
${MonolithImageSizeFragmentDoc}
${RecommendedRingSizeFragmentDoc}
${RingSizeFragmentDoc}`;
export const RingBuilderMountFragmentFragmentDoc = gql`
    fragment ringBuilderMountFragment on RingBuilderMountFragment {
  __typename
  id
  ring {
    ...ringBuilderMountEngagementRing
    ...engagementRingLink
    ...productPageMeta
    variationsByCentreStoneShape {
      ...catalogueEngagementRingInput
      centreStoneConstraints {
        shape {
          systemCode
        }
      }
    }
  }
  signatureStone {
    ...signatureStoneInput
    image
    crystal {
      __typename
      translation(locale: $locale) {
        name
      }
    }
    color {
      __typename
      translation(locale: $locale) {
        name
      }
    }
    segmentName
  }
  totalSalePrice(region: $region, currency: $currency) {
    ...money
  }
}
    ${RingBuilderMountEngagementRingFragmentDoc}
${EngagementRingLinkFragmentDoc}
${ProductPageMetaFragmentDoc}
${CatalogueEngagementRingInputFragmentDoc}
${SignatureStoneInputFragmentDoc}
${MoneyFragmentDoc}`;
export const RingBuilderCentreStoneFragmentFragmentDoc = gql`
    fragment ringBuilderCentreStoneFragment on RingBuilderCentreStoneFragment {
  __typename
  id
  stone {
    __typename
    ... on GemsApiStone {
      stone {
        ...stone
        ...gemsApiStoneAnalytics
        ...gemsApiCertificate
      }
    }
    ...nonSkuGemstone
    ...nonSkuLabGrown
    ...nonSkuGemstoneAnalytics
    ...nonSkuLabGrownAnalytics
  }
  totalSalePrice(region: $region, currency: $currency) {
    ...money
  }
}
    ${StoneFragmentDoc}
${GemsApiStoneAnalyticsFragmentDoc}
${GemsApiCertificateFragmentDoc}
${NonSkuGemstoneFragmentDoc}
${NonSkuLabGrownFragmentDoc}
${NonSkuGemstoneAnalyticsFragmentDoc}
${NonSkuLabGrownAnalyticsFragmentDoc}
${MoneyFragmentDoc}`;
export const RingBuilderFragmentFragmentDoc = gql`
    fragment ringBuilderFragment on RingBuilderFragment {
  __typename
  ... on RingBuilderMountFragment {
    ...ringBuilderMountFragment
  }
  ... on RingBuilderCentreStoneFragment {
    ...ringBuilderCentreStoneFragment
  }
}
    ${RingBuilderMountFragmentFragmentDoc}
${RingBuilderCentreStoneFragmentFragmentDoc}`;
export const RbFragmentDoc = gql`
    fragment rb on RingBuilder {
  __typename
  id
  productId
  position1 {
    ...ringBuilderFragment
  }
  position2 {
    ...ringBuilderFragment
  }
  errors
  image {
    small_x2: size(name: SMALL_X2) {
      ...monolithImageSize
    }
    large_x2: size(name: LARGE_X2) {
      ...monolithImageSize
    }
  }
  salePrice(currency: $currency, region: $region) {
    ...taxSnippet
  }
  financeOptionsAffirm(currency: $currency, region: $region) {
    ...affirmFinanceOptions
  }
  financeOptionsKlarna(currency: $currency, region: $region) {
    ...klarnaFinanceOptions
  }
  failure {
    errors {
      __typename
    }
  }
}
    ${RingBuilderFragmentFragmentDoc}
${MonolithImageSizeFragmentDoc}
${TaxSnippetFragmentDoc}
${AffirmFinanceOptionsFragmentDoc}
${KlarnaFinanceOptionsFragmentDoc}`;